export default "__VITE_ASSET__8ee47cda__"